import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class UserProduct extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";

    public productList: BASEAPI.Product[] = [];

    public async created() {
        if (await this.isLoginRedirect(true)) return;
        
        await this.init();

    }

    @Watch('$route')
    public async init() {
        if (await this.isLoginRedirect(true)) return;

        this.kurukuru = true;
        this.productList = [];

        let res = await BASEAPI.ProductController.getBuyProductListUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            return;
        }
        this.productList = res.data;
        
        this.kurukuru = false;
    }
}
